(function () {
    angular.module('tradersyard').factory('MessageManagerFactory', [
        '$rootScope',
        'graph-message-factory',
        'WebSocket',
        '$timeout',
        'scrollKeeper',
        function ($rootScope, ApiMessageFactory, WebSocket, $timeout, scrollKeeper) {
            var Manager = {};

            function Instance(id, entry, $scope) {
                var self = this;

                var keepScroll = scrollKeeper('#message-container');

                self.Id = id;
                self.Entry = entry;
                self.Guid = [];
                self.Data = [];
                self.Let = 0;
                self.Lock = 0;
                self.Page = 0;
                self.totalPages = 0;
                self.Glue = true;
                self.Focus = false;
                self.Form = {
                    content: '',
                };
                self.Inited = false;
                self.preloader = false;

                /**
                 * Most recent promise that is being resolved.
                 *
                 * @type {Promise|undefined}
                 */
                self.currentPromise = undefined;

                /**
                 * @returns {boolean}
                 */
                function Sucess(response, action) {
                    if (response.data.state === 0) {
                        switch (action) {
                            case 'Query':
                                return response.data.data.length > 0;

                            default:
                                return true;
                        }
                    } else {
                        return false;
                    }
                }

                self.Touch = function (_meeting) {
                    $timeout(function () {
                        angular.forEach(self.Data, function (message) {
                            message.unread = false;
                        });

                        if (self.Id > 0) {
                            ApiMessageFactory.entry(self.Id).touch();
                        }
                    }, 500);
                };

                self.Add = function (message) {
                    if (message.type === 'message') {
                        ++self.Let;
                        self.Data.push(message);

                        return self;
                    }
                };

                self.Blockquote = function (message) {
                    $scope.$broadcast('message:blockquote', {
                        place: {
                            id: self.Id,
                            name: self.Entry,
                        },
                        data: message,
                    });
                };

                /**
                 * Filter and append new messages.
                 * @param {Object[]} data New messages list
                 */
                self.Concat = function (data) {
                    keepScroll.rememberPosition();

                    /**
                     * Filters out unwanted action type messages.
                     * @param message Any chat message. Both `action` and `message` type.
                     * @returns {boolean}
                     */
                    function filterActionTypeMessages(message) {
                        if (message.type === 'message') return true;

                        var validActionTypes = ['meeting.invite'];

                        return (
                            message.content &&
                            message.content.type &&
                            validActionTypes.indexOf(message.content.type) !== -1
                        );
                    }

                    var filteredMessages = data.filter(filterActionTypeMessages);
                    self.Data = filteredMessages.reverse().concat(self.Data);

                    keepScroll.restorePosition();

                    return self;
                };

                self.Digest = function () {
                    if (!$rootScope.$$phase) {
                        $rootScope.$digest();
                    }

                    return self;
                };

                /**
                 * Performs query for new messages. Does not allow more than one request at a time.
                 * Same Promise will be returned for unresolved calls.
                 *
                 * It duplicates some of the logic of `Query` because I have no idea what it does ¯\_(ツ)_/¯
                 *
                 * @see self.Query
                 * @returns Promise
                 */
                self.QueryPromise = function () {
                    self.Inited = true;

                    // return early with last promise we issued
                    if (self.Lock !== 0) return self.currentPromise;

                    // ... or it's a fresh call, so we need to build our promise
                    self.Lock = 1;
                    ++self.Page;
                    self.preloader = true;

                    // noinspection DuplicatedCode
                    self.currentPromise = ApiMessageFactory.entry(self.Id)
                        .query({
                            params: {
                                limit: 25,
                                page: self.Page,
                                let: self.Let,
                                types: 'message',
                            },
                        })
                        .then(function (response) {
                            if (Sucess(response, 'Query') === true) {
                                self.Concat(response.data.data);
                            }

                            self.totalPages = response.data.pages;

                            return self;
                        })
                        .finally(function () {
                            // take the lock off on either success or error
                            self.Lock = 0;
                            self.preloader = false;
                        });

                    return self.currentPromise;
                };

                /**
                 * Query for messages. Performs locking, so only one active request can be made.
                 *
                 * @deprecated Don't use this anymore. See `QueryPromise`.
                 */
                self.Query = function (next) {
                    self.Inited = true;
                    if (self.Lock === 0) {
                        self.Lock = 1;
                        ++self.Page;

                        if (self.Page === 1) {
                            self.preloader = true;
                        }

                        ApiMessageFactory.entry(self.Id)
                            .query({
                                params: {
                                    limit: 25,
                                    page: self.Page,
                                    let: self.Let,
                                    types: 'message',
                                },
                            })
                            .then(function (response) {
                                if (Sucess(response, 'Query') === true) {
                                    self.Concat(response.data.data);
                                }

                                setTimeout(function () {
                                    $rootScope.$digest();
                                });

                                self.Lock = 0;

                                if (next) next();

                                if (self.preloader) {
                                    self.preloader = false;
                                }

                                return self;
                            });
                    }
                };

                self.Publish = function (message, guid, callback) {
                    if (self.Lock === 0) {
                        self.Lock = 1;

                        self.Guid.push('C-' + guid);

                        self.Glue = false;

                        ApiMessageFactory.entry(self.Id)
                            .create(message ? message : self.Form, {
                                headers: {
                                    'X-Ph-Guid': 'C-' + guid,
                                },
                            })
                            .then(function (response) {
                                if (Sucess(response) === true) {
                                    self.Add(response.data.data);

                                    // ignore public chat
                                    if (self.Id > 0) {
                                        ApiMessageFactory.entry(self.Id).touch();
                                    }

                                    self.Form = {
                                        content: '',
                                    };

                                    self.Glue = true;

                                    self.Digest();
                                }

                                self.Lock = 0;

                                if (callback) callback(response);

                                return self;
                            });
                    }
                };

                self.Update = function (id, message) {
                    $scope.$broadcast('message:edit', message);
                };

                self.Delete = function (id, message, guid) {
                    self.Guid.push(guid);

                    ApiMessageFactory.entry(self.Id)
                        .delete(id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                self.Data.forEach(function (item, index) {
                                    if (item.id === id) {
                                        self.Data.splice(index, 1);
                                        --self.Let;
                                    }
                                });
                            }

                            setTimeout(function () {
                                $rootScope.$digest();
                            });
                        });
                };

                WebSocket.on('message:create', function (data) {
                    if (data.place.name === self.Entry && parseInt(data.place.id) === parseInt(self.Id)) {
                        var index = self.Guid.indexOf(data.guid);

                        if (index === -1) {
                            self.Add(data.node);

                            if (
                                data.node.type === 'message' &&
                                data.node.alert === true &&
                                parseInt(data.node.owner.id) !== parseInt($scope.me.id)
                            ) {
                                /**
                                 *  Improvement #13440: TY // Switching of sound notification
                                 *
                                 *  https://issues.agenatrader.com/issues/13440
                                 */
                                // var Sound = new Audio('/sounds/oldspice.mp3');
                                // Sound.volume = 0.2;
                                // Sound.play();
                            }

                            self.Digest();
                        } else {
                            self.Guid.splice(index, 1);
                        }
                    }
                });

                WebSocket.on('message:update', function (data) {
                    if (data.place.name === self.Entry && parseInt(data.place.id) === parseInt(self.Id)) {
                        angular.forEach(self.Data, function (message, i) {
                            if (parseInt(message.id) === parseInt(data.node.id)) {
                                self.Data[i] = data.node;
                            }
                        });
                    }
                });

                WebSocket.on('message:delete', function (data) {
                    if (data.place.name === self.Entry && parseInt(data.place.id) === parseInt(self.Id)) {
                        angular.forEach(self.Data, function (message, i) {
                            if (parseInt(message.id) === parseInt(data.node.id)) {
                                self.Data.splice(i, 1);
                                self.Let--;

                                self.Digest();

                                var index = self.Guid.indexOf(data.guid);

                                if (index !== -1) {
                                    self.Guid.splice(index, 1);
                                }
                            }
                        });
                    }
                });
            }

            function Encode(id, entry) {
                return [entry ? entry : 'meeting', id].join(':');
            }

            function Get(id, entry, $scope) {
                var room = Encode(id, entry);
                var data = Manager[room];

                if (data === undefined) {
                    Manager[room] = new Instance(id, entry ? entry : 'meeting', $scope);

                    // Use improved function for querying messages.
                    // This provides better lock/unlock control in cooperation with `flexScroll` directive.
                    Manager[room].QueryPromise();
                }

                return Manager[room];
            }

            return {
                Get: Get,
            };
        },
    ]);
})();
